var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "feet" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.downloadTemplate(1)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.DownloadTheTemplate")))]
          ),
          _c("upload-excel", {
            directives: [
              {
                name: "permit",
                rawName: "v-permit:remove",
                value: "btn:payable:quoteManagement:addEdit",
                expression: "'btn:payable:quoteManagement:addEdit'",
                arg: "remove",
              },
            ],
            staticClass: "feet-btn",
            attrs: {
              "on-success": _vm.importLogistics,
              "but-name": _vm.BulkImport,
            },
          }),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.downloadTemplate(2)
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.DownloadTheQuote")))]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": true,
            title: _vm.$t("basicData.tips"),
            visible: _vm.dialogVisible,
            width: "400",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            _vm._l(_vm.errData, function (item, ind) {
              return _c(
                "div",
                {
                  key: ind,
                  staticStyle: { color: "#f00", "margin-bottom": "8px" },
                },
                [_vm._v(_vm._s(item))]
              )
            }),
            0
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basicData.determine")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }